/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboCashManagementBadRequestResponse,
  BboCashManagementForbiddenResponse,
  FailureResponseResponse,
  NotFoundResponse,
  SystemCashListResponseResponse,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * Returns list of system cash details of all accounting locations
 * @summary System cash value of all accounting locations
 */
export const getSystemCashAllAccountingLocations = (signal?: AbortSignal) => {
  return customInstance<SystemCashListResponseResponse>({
    url: `/BboCashManagementService/v1/system-cash/accounting-location`,
    method: 'get',
    signal,
  });
};

export const getGetSystemCashAllAccountingLocationsQueryKey = () => {
  return [`/BboCashManagementService/v1/system-cash/accounting-location`] as const;
};

export const getGetSystemCashAllAccountingLocationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSystemCashAllAccountingLocations>>,
  TError = ErrorType<
    | BboCashManagementBadRequestResponse
    | UnauthorizedResponse
    | BboCashManagementForbiddenResponse
    | NotFoundResponse
    | FailureResponseResponse
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSystemCashAllAccountingLocations>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSystemCashAllAccountingLocationsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSystemCashAllAccountingLocations>>> = ({
    signal,
  }) => getSystemCashAllAccountingLocations(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSystemCashAllAccountingLocations>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSystemCashAllAccountingLocationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSystemCashAllAccountingLocations>>
>;
export type GetSystemCashAllAccountingLocationsQueryError = ErrorType<
  | BboCashManagementBadRequestResponse
  | UnauthorizedResponse
  | BboCashManagementForbiddenResponse
  | NotFoundResponse
  | FailureResponseResponse
>;

/**
 * @summary System cash value of all accounting locations
 */
export const useGetSystemCashAllAccountingLocations = <
  TData = Awaited<ReturnType<typeof getSystemCashAllAccountingLocations>>,
  TError = ErrorType<
    | BboCashManagementBadRequestResponse
    | UnauthorizedResponse
    | BboCashManagementForbiddenResponse
    | NotFoundResponse
    | FailureResponseResponse
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSystemCashAllAccountingLocations>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetSystemCashAllAccountingLocationsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
